import { useState } from 'react';
import { Button, Typography } from 'antd';
import {
  LegalAcceptanceHistory,
  LegalDocumentType,
} from '@/api/legalDocuments';
import LegalAcceptanceHistoryModal from './LegalAcceptanceHistoryModal';

interface Props {
  history?: LegalAcceptanceHistory;
  loading?: boolean;
  isError?: boolean;
  // Franchisor profiles have multiple users → show the modal's "User" column.
  // Consultant profiles are a single user → hide it.
  showUserColumn: boolean;
}

const DOCUMENT_TYPES: Array<{ type: LegalDocumentType; label: string }> = [
  { type: 'terms', label: 'Terms & Conditions' },
  { type: 'privacy', label: 'Privacy Policy' },
];

export default function LegalDocumentsSection({
  history,
  loading,
  isError,
  showUserColumn,
}: Props): JSX.Element {
  const [openType, setOpenType] = useState<LegalDocumentType | null>(null);

  return (
    <div className={'details-section'}>
      <Typography.Text
        className={'general-info-text'}
        style={{
          textTransform: 'uppercase',
          fontWeight: 600,
          letterSpacing: 0.5,
          display: 'block',
          marginBottom: 12,
        }}
      >
        Legal Documents
      </Typography.Text>

      {DOCUMENT_TYPES.map(({ type, label }) => (
        <div className={'details-section-line'} key={type}>
          <Typography.Text className={'general-info-text'}>
            {label}
          </Typography.Text>
          {/* Button (not Typography.Link) so it's a real, keyboard-focusable
              control with button semantics; padding stripped to sit inline. */}
          <Button
            type="link"
            onClick={() => setOpenType(type)}
            style={{ padding: 0, height: 'auto' }}
          >
            View History
          </Button>
        </div>
      ))}

      <LegalAcceptanceHistoryModal
        open={openType !== null}
        onClose={() => setOpenType(null)}
        documentType={openType ?? 'terms'}
        rows={openType ? history?.[openType] ?? [] : []}
        showUserColumn={showUserColumn}
        loading={loading}
        isError={isError}
      />
    </div>
  );
}
